import date from './date'
export default function filterResult(data) {
  data = data.map(function(item) {
    if(item.CreateTime) {
      var time = item.CreateTime.split('.')[0].replace(/\-/g,"/").replace(/T/g," ")
      item.CreateTimeFormat = date('Y-m-d H:i',new Date(time).getTime()/1000)
    }

    if(item.Roles) {
      let roleArr = []
      item.Roles.map(function (role) {
        roleArr.push(role.Name)
      })
      item.RolesFormat = roleArr.join(',')
    }

    return item
  })

  return data
}



// WEBPACK FOOTER //
// ./src/assets/js/lib/filterResult.js